/**
 * Hook to update last_active when the app returns to foreground
 * P2: No periodic interval — central throttle in lastActiveUpdater
 */

import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { updateUserLastActiveOnForeground } from '../utils/lastActiveUpdater';

/**
 * Foreground-only last_active sync (tab visible / app resume in browser)
 */
export function useLastActive() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        updateUserLastActiveOnForeground(user.id).catch(err => {
          console.warn('⚠️ Failed to update last_active on foreground:', err);
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user?.id]);
}
